var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaqIcon = function SvgFaqIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.375,
    d: "M26.917 29.181h-6.334l-7.046 4.687c-1.045.696-2.454-.048-2.454-1.314V29.18c-4.75 0-7.916-3.167-7.916-7.917v-9.5c0-4.75 3.166-7.916 7.916-7.916h15.834c4.75 0 7.916 3.166 7.916 7.916v9.5c0 4.75-3.166 7.917-7.916 7.917Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.375,
    d: "M19 17.986v-.332c0-1.077.665-1.647 1.33-2.106.65-.443 1.298-1.013 1.298-2.058A2.622 2.622 0 0 0 19 10.86a2.622 2.622 0 0 0-2.628 2.629M18.993 21.77h.014",
    opacity: 0.4
  })));
};
export default SvgFaqIcon;